import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject2() {
  const data = _taggedTemplateLiteral(["\n                        <a href=\"", "work/", "\" class=\"", "\" ref=", ">\n                            <div class=", ">\n                                <img src=\"", "work/", "\" class=", " @load=", "/>\n                            </div>\n                        </a>\n                    "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  const data = _taggedTemplateLiteral(["\n            <div class=\"u-hidden\" ref=", ">\n                <div class=", ">\n                    ", "\n                    <div class=", "></div>\n                    <div class=", "></div>\n                    <div class=", "></div>\n                </div>\n            </div>\n        "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { Component, html } from 'lib/component';
import store from 'lib/store';
import { ref } from 'lib/lit-ref';
import anime from 'animejs';
import size from 'size';
import * as styles from './styles';
export default class Works extends Component {
  init(options) {
    let works = store.get('content').work;

    switch (options.route.current.route) {
      case 'campaigns':
        this.works = works.filter(work => work.type == 'campaign');
        break;

      case 'more':
        this.works = works.filter(work => work.type == 'brand');
        break;
    }
  }

  render() {
    return html(_templateObject(), ref(this, 'wrapper'), styles.center, this.works.map(project => html(_templateObject2(), ENV.baseURL, project.slug, styles.work, ref(this, 'posters'), styles.posterWrapper, ENV.assetsURL, project.poster, styles.poster, this.onImageLoaded)), styles.work, styles.work, styles.work);
  }

  onRender() {
    this.classList.add(styles.works);
  }

  onResize() {}

  onImageLoaded(event) {
    event.target.classList.add('is-loaded');
  }

  animateIn(params, complete) {
    anime({
      targets: this,
      opacity: [0, 1],
      easing: 'easeOutCubic',
      duration: 600,
      begin: () => {
        this.refs.wrapper.classList.remove('u-hidden');
      }
    });
    anime({
      targets: this.refs.posters,
      opacity: [0, 1],
      duration: 400,
      easing: 'linear',
      delay: anime.stagger(80),
      complete
    });
  }

  animateOut(params, complete) {
    anime({
      targets: this,
      opacity: 0,
      easing: 'easeOutCubic',
      duration: 600,
      complete
    });
  }

  onDestroy() {}

}
customElements.define('rv-works', Works);